/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PurchaseOrderStatus } from './';
import {
    PurchaseOrderStatusFromJSON,
    PurchaseOrderStatusFromJSONTyped,
    PurchaseOrderStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface PurchaseOrderMonitoringResource
 */
export interface PurchaseOrderMonitoringResource {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderMonitoringResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderMonitoringResource
     */
    identifier: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderMonitoringResource
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderMonitoringResource
     */
    amount: number;
    /**
     * 
     * @type {PurchaseOrderStatus}
     * @memberof PurchaseOrderMonitoringResource
     */
    status: PurchaseOrderStatus;
    /**
     * 
     * @type {Date}
     * @memberof PurchaseOrderMonitoringResource
     */
    creationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PurchaseOrderMonitoringResource
     */
    expirationDate?: Date;
}

/**
 * Check if a given object implements the PurchaseOrderMonitoringResource interface.
 */
export function instanceOfPurchaseOrderMonitoringResource(value: object): value is PurchaseOrderMonitoringResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    return true;
}

export function PurchaseOrderMonitoringResourceFromJSON(json: any): PurchaseOrderMonitoringResource {
    return PurchaseOrderMonitoringResourceFromJSONTyped(json, false);
}

export function PurchaseOrderMonitoringResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseOrderMonitoringResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'identifier': json['identifier'],
        'label': json['label'] == null ? undefined : json['label'],
        'amount': json['amount'],
        'status': PurchaseOrderStatusFromJSON(json['status']),
        'creationDate': (new Date(json['creationDate'])),
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
    };
}

export function PurchaseOrderMonitoringResourceToJSON(value?: PurchaseOrderMonitoringResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'identifier': value['identifier'],
        'label': value['label'],
        'amount': value['amount'],
        'status': PurchaseOrderStatusToJSON(value['status']),
        'creationDate': ((value['creationDate']).toISOString()),
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate'] as any).toISOString()),
    };
}

